module.exports = __webpack_public_path__ + "img/671.cd2f5b8d.png";